import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { SplitBarWrapper } from '@common/components/BookingForms';
import { FORMWIDTH } from '../FormSteps.styles';

export const PackagesSplitBarWrapper = styled(SplitBarWrapper)`
  justify-content: center;
`;

export const TitleWrapper = styled.div`
  margin-top: 30px;
  max-width: ${FORMWIDTH}px;
  width: 100%;
  justify-self: center;
  button {
    width: fit-content;
  }
  h2 {
    margin: 0;
  }
  @media screen and (max-width: 600px) {
    max-width: 100%;
    width: 100%;
    padding: 10px 20px 0;
  }
`;

export const GuestDetailsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  justify-content: center;
  margin-top: -30px;
  max-width: 1280px;
  padding: 20px;
  padding-bottom: 30px;
  ${media.md`
    margin-top: -20px;
  `}
`;
